import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { BlockCard } from '../lib/block-card.js';
import { InlineMarkdown } from '../lib/inline-markdown.js';
import { cx } from '../lib/cx.js';
import { STATE_TEXT_CLASS, STATE_TONES } from '../lib/state-styles.js';
const MetricSchema = z
    .object({
    label: z.string(),
    value: z.union([z.string(), z.number()]),
    state: z.enum(STATE_TONES).optional(),
    hint: z.string().optional(),
})
    .strict();
export const MetricGridPropsSchema = z
    .object({
    title: z.string().optional(),
    metrics: z.array(MetricSchema),
})
    .strict();
/**
 * Per-tile border tint by state. Neutral tiles use the plain border token;
 * a non-neutral state tints the outline with its semantic color so the tile
 * reads as significant at a glance. Full literal class strings so Tailwind
 * can see every utility statically.
 */
const STATE_TILE_BORDER_CLASS = {
    ok: 'border-success/40',
    warn: 'border-warning/40',
    alert: 'border-danger/40',
    info: 'border-info/40',
    neutral: 'border-border',
};
/** Renders a `metric_grid` block as a grid of outlined KPI tiles. */
export function MetricGridPrimitive({ title, metrics }) {
    return (_jsx(BlockCard, { title: title, children: _jsx("dl", { className: "grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6", children: metrics.map((metric, index) => {
                const tone = metric.state ?? 'neutral';
                return (_jsxs("div", { className: cx('rounded-lg border p-3', STATE_TILE_BORDER_CLASS[tone]), children: [_jsx("dd", { className: cx('text-2xl font-semibold tracking-tight tabular-nums', metric.state ? STATE_TEXT_CLASS[metric.state] : 'text-foreground'), children: metric.value }), _jsx("dt", { className: "mt-1 text-xs font-medium text-muted-foreground", children: metric.label }), metric.hint ? (_jsx("p", { className: "mt-0.5 text-xs text-muted-foreground/80", children: _jsx(InlineMarkdown, { children: metric.hint }) })) : null] }, index));
            }) }) }));
}
